"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        var componentManager;
        (function (componentManager) {
            let _sectors;
            let _definitions = new Map();
            function registerSectors(sectors) {
                _sectors = sectors;
            }
            componentManager.registerSectors = registerSectors;
            function getSectors() {
                return _sectors;
            }
            componentManager.getSectors = getSectors;
            function registerDefinitions(defs) {
                Object.entries(defs).forEach(([type, def]) => registerDefinition(type, def));
            }
            componentManager.registerDefinitions = registerDefinitions;
            function registerDefinition(type, definition) {
                _definitions.set(type, definition);
            }
            componentManager.registerDefinition = registerDefinition;
            function getDefinitions() {
                return Array.from(_definitions.values());
            }
            componentManager.getDefinitions = getDefinitions;
            function isRegistered(componentType) {
                return _definitions.has(componentType);
            }
            componentManager.isRegistered = isRegistered;
            function getByCategory(category) {
                return Array.from(_definitions.values()).filter(def => def.category === category);
            }
            componentManager.getByCategory = getByCategory;
            function getDefinition(type) {
                return _definitions.get(type);
            }
            componentManager.getDefinition = getDefinition;
            function getDefaultProperties(definition) {
                const properties = {};
                Object.entries(definition.properties).forEach(([key, propDef]) => {
                    if (propDef.defaultValue !== undefined) {
                        const propKey = propDef.path || key;
                        if (propDef.path) {
                            designerv2.setPropertyByPath(properties, propDef.path, appn.utils.deepClone(propDef.defaultValue));
                        }
                        else {
                            properties[propKey] = appn.utils.deepClone(propDef.defaultValue);
                        }
                    }
                });
                return properties;
            }
            componentManager.getDefaultProperties = getDefaultProperties;
            function createComponent(type) {
                const def = _definitions.get(type);
                if (!def)
                    return null;
                const newComponent = {
                    id: appn.utils.newGuid(true),
                    type: type,
                    gridPosition: { x: 0, y: 0, w: 4, h: 4 },
                };
                const dataQueryPropNames = getDataQueryPropertyNames(def);
                for (const dataQueryPropName of dataQueryPropNames) {
                    if (!newComponent[dataQueryPropName]) {
                        newComponent[dataQueryPropName] = {
                            name: 'default',
                            primaryDataset: { alias: 'primary' }
                        };
                    }
                }
                for (const propName in def.properties) {
                    const propDef = def.properties[propName];
                    if (propDef.defaultValue !== undefined) {
                        if (propDef.path)
                            appn.designerv2.setPropertyByPath(newComponent, propDef.path, JSON.parse(JSON.stringify(propDef.defaultValue)));
                        else
                            newComponent[propName] = JSON.parse(JSON.stringify(propDef.defaultValue));
                    }
                }
                return newComponent;
            }
            componentManager.createComponent = createComponent;
            function getDataQueryPropertyNames(definition) {
                if (!definition)
                    return [];
                const dataQueryNames = new Set();
                for (const propName in definition.properties) {
                    const propDef = definition.properties[propName];
                    if (propDef.type === 'datasetSelector' && propDef.path) {
                        const rootPropName = propDef.path.split('.')[0];
                        dataQueryNames.add(rootPropName);
                    }
                }
                return Array.from(dataQueryNames);
            }
            componentManager.getDataQueryPropertyNames = getDataQueryPropertyNames;
        })(componentManager = designerv2.componentManager || (designerv2.componentManager = {}));
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
